import { updateCompanyPerformanceQuestion } from 'api/hooks/company-performance-question/companyPerformanceQuestionsService';
import {
    CompanyPerformanceQuestion,
    CreateUpdateCompanyPerformanceQuestion,
} from 'api/hooks/company-performance-question/companyPerformanceQuestionsTypes';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { modifyError } from 'utils/error-modifer-utils';

type Props = {
    onError?: (error: Error) => void;
    onSuccess?: (data: CompanyPerformanceQuestion) => void;
};

export const useUpdateCompanyPerformanceQuestion = ({
    onSuccess = () => {},
    onError = () => {},
}: Props) => {
    const onErrorModified = (error: any) => {
        const errors = modifyError(error?.response?.data);
        if (errors) {
            for (const err of errors) {
                toast.error(err);
            }
        } else {
            toast.error('Internal error, please contact administrator');
        }

        if (onError) {
            onError(error);
        }
    };
    const mutation = useMutation(
        async (input: {
            id: string;
            request: CreateUpdateCompanyPerformanceQuestion;
        }) => await updateCompanyPerformanceQuestion(input.id, input.request),
        {
            onSuccess,
            onError: onErrorModified,
        }
    );

    return {
        mutate: mutation.mutate,
        isLoading: mutation.isLoading,
        error: mutation.error,
    };
};
